import { configureStore } from "@reduxjs/toolkit";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk"; // Import Redux Thunk
import rootReducer from "./rootReducer";

// Ajoute Redux Thunk dans le tableau des middlewares
const middlewares = [thunk];

const persistConfig = {
  key: PERSIST_STORE_NAME,
  keyPrefix: "",
  storage,
  whitelist: ["auth", "locale", "notifications", "booking"],
};

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer()),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares), // Ajoute les middlewares ici
  devTools: process.env.NODE_ENV === "development",
});

store.asyncReducers = {};

// Fonction pour injecter dynamiquement des reducers
export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(
    persistReducer(persistConfig, rootReducer(store.asyncReducers))
  );
  persistor.persist();
  return store;
};

// Persistor pour maintenir l'état persistant
export const persistor = persistStore(store);

export default store;
